import axios from "axios";
import urlconfig from "../_config";

const VERSION = "v1";

const tokenConfig = () => {
  const token = localStorage.getItem("token");
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  if (token) {
    config.headers["Authorization"] = `Token ${token}`;
  }
  return config;
};

// Base paths - following the same pattern as other APIs
const LLM_MODEL_CONFIGS_BASE = `${urlconfig.appapi}/${VERSION}/llm-usage/llm-model-configs/`;
const LLM_USAGE_LOGS_BASE = `${urlconfig.appapi}/${VERSION}/llm-usage/llm-usage-logs/`;

/**
 * LLM Model Configs
 */
export const GET_LLM_MODEL_CONFIGS = (payload) => {
  const params = new URLSearchParams();
  if (payload) {
    Object.keys(payload).forEach(key => {
      if (payload[key] !== null && payload[key] !== undefined && payload[key] !== '') {
        params.append(key, payload[key]);
      }
    });
  }
  const queryString = params.toString();
  return axios.get(
    `${LLM_MODEL_CONFIGS_BASE}${queryString ? `?${queryString}` : ""}`,
    tokenConfig()
  );
};

export const FETCH_LLM_MODEL_CONFIG = ({ id }) =>
  axios.get(`${LLM_MODEL_CONFIGS_BASE}${id}/`, tokenConfig());

export const ADD_LLM_MODEL_CONFIG = (payload) =>
  axios.post(LLM_MODEL_CONFIGS_BASE, payload, tokenConfig());

export const EDIT_LLM_MODEL_CONFIG = (payload) =>
  axios.patch(`${LLM_MODEL_CONFIGS_BASE}${payload.id}/`, payload, tokenConfig());

export const DELETE_LLM_MODEL_CONFIG = ({ id }) =>
  axios.delete(`${LLM_MODEL_CONFIGS_BASE}${id}/`, tokenConfig());

/**
 * LLM Usage Logs
 */
export const GET_LLM_USAGE_LOGS = (payload) => {
  const params = new URLSearchParams();
  if (payload) {
    Object.keys(payload).forEach(key => {
      if (payload[key] !== null && payload[key] !== undefined && payload[key] !== '') {
        params.append(key, payload[key]);
      }
    });
  }
  const queryString = params.toString();
  return axios.get(
    `${LLM_USAGE_LOGS_BASE}${queryString ? `?${queryString}` : ""}`,
    tokenConfig()
  );
};

export const FETCH_LLM_USAGE_LOG = ({ id }) =>
  axios.get(`${LLM_USAGE_LOGS_BASE}${id}/`, tokenConfig());

export const ADD_LLM_USAGE_LOG = (payload) =>
  axios.post(LLM_USAGE_LOGS_BASE, payload, tokenConfig());

export const EDIT_LLM_USAGE_LOG = (payload) =>
  axios.patch(`${LLM_USAGE_LOGS_BASE}${payload.id}/`, payload, tokenConfig());

export const DELETE_LLM_USAGE_LOG = ({ id }) =>
  axios.delete(`${LLM_USAGE_LOGS_BASE}${id}/`, tokenConfig());

// Statistics endpoint (if needed)
export const LLM_MODEL_CONFIG_STATISTICS = (payload) => {
  const params = new URLSearchParams();
  if (payload) {
    Object.keys(payload).forEach(key => {
      if (payload[key] !== null && payload[key] !== undefined && payload[key] !== '') {
        params.append(key, payload[key]);
      }
    });
  }
  const queryString = params.toString();
  return axios.get(
    `${LLM_MODEL_CONFIGS_BASE}statistics/${queryString ? `?${queryString}` : ""}`,
    tokenConfig()
  );
};

export const LLM_USAGE_LOG_STATISTICS = (payload) => {
  const params = new URLSearchParams();
  if (payload) {
    Object.keys(payload).forEach(key => {
      if (payload[key] !== null && payload[key] !== undefined && payload[key] !== '') {
        params.append(key, payload[key]);
      }
    });
  }
  const queryString = params.toString();
  return axios.get(
    `${LLM_USAGE_LOGS_BASE}statistics/${queryString ? `?${queryString}` : ""}`,
    tokenConfig()
  );
};